import { createAction, props, union } from '@ngrx/store';
import { RfrOrdSaveQueryI } from 'src/app/api/rfr-ord-save/rfr-ord-save.query.int';

export const load = createAction('[RFR ORD / Save] Get', props<{ query: RfrOrdSaveQueryI }>());
export const received = createAction('[RFR ORD / Save] Received', props<Record<string, unknown>>());
export const reset = createAction('[RFR ORD / Save] Reset', props<Record<string, unknown>>());
export const error = createAction('[RFR ORD / Save] Error', props<{ messageText: string }>());

const actions = union({
  error,
  load,
  received,
  reset,
});
export type Actions = typeof actions;
